<!-- Header -->
<div class="header">
  <div class="flex">
    <button
      aria-label="Add"
      mat-stroked-button
      color="primary"
      [matTooltip]="'Add_User' | translate"
      (click)="goToAddUsers()"
    >
      <mat-icon>add</mat-icon>
      {{ 'COMPANY_DETAILS_HEADER.add_users' | translate }}
    </button>

    <div [matTooltip]="this.selectedUsers.hasValue()?('COMPANY_DETAILS_HEADER.remove_users' | translate) : ('Remove_User_Disabled' | translate)">
      <button
        aria-label="Trash"
        mat-stroked-button
        color="primary"
        [disabled]="!selectedUsers.hasValue()"
        (click)="goToDeleteUsers()"
      >
        <mat-icon>delete_outline</mat-icon>
        {{'COMPANY_DETAILS_HEADER.remove_users' | translate}}
        
      </button>
    </div>

    <button
      aria-label="Filter"
      mat-stroked-button
      color="primary"
      [matTooltip]="'Filter_Roles' | translate"
      [matMenuTriggerFor]="appMenu"
      (menuClosed)="showFilters()"
    >
      <mat-icon>filter_alt</mat-icon>
      {{ 'COMPANY_DETAILS_HEADER.filter-by-roles' | translate }} {{ getSelectedRoles() == null || getSelectedRoles()?.length === 0 ?  '' : '(' + getSelectedRoles()?.length + ')' }}
    </button>
    <mat-menu #appMenu="matMenu" xPosition="before">
      <div class="filter-header">
        <span class="subtitle-1">{{ 'COMPANY_DETAILS_HEADER.filter-by-roles' | translate }}</span>
        <div class="spacer"></div>
        <button mat-button color="primary" (click)="clearAllFilters()"> {{ 'COMPANY_DETAILS_HEADER.clear-all' | translate }}</button>
      </div>
      <hr class="margin-bottom-zero"/>
      <div class="roles-row">
        @for (role of roles; track role) {
        <div class="roles-list-item">
          <mat-checkbox
            color="primary"
            [checked]="role.isSelected"
            (click)="filterData(role); $event.stopPropagation()"
          >
            {{ role?.role }}
          </mat-checkbox>
        </div>
        }
      </div>
    </mat-menu>
    <mat-form-field
      [subscriptSizing]="'dynamic'"
      appearance="outline"
      floatLabel="always"
    >
      <mat-label>{{ 'USERS_SEARCH.search' | translate }}</mat-label>
      <input
        matInput
        [(ngModel)]="queryString"
        [placeholder]="'USERS_SEARCH.search_placeholder' | translate"
        (input)="monitorSearch(queryString)"
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>

  @if (showFilter) {
  <div>
    <mat-chip-set >
    <span class="filter-text">{{ 'COMPANY_DETAILS_HEADER.filtered-by' | translate}} :</span>
      @for (role of getSelectedRoles(); track role) {
      <mat-chip
        (removed)="filterData(role)"
      >
        {{ role?.role }}
        <span matChipRemove><mat-icon>cancel</mat-icon></span>
      </mat-chip>
      }
    </mat-chip-set>
  </div>
  }
</div>

<!-- table -->
@if (_appUserServ.noRecordFound) {
<app-not-found
  [displayMessage]="message"
></app-not-found>
}
<table
  class="mat-elevation-z0"
  mat-table
  [dataSource]="userListDataSource"
  [ngClass]="_appUserServ.noRecordFound ? 'hide' : ''"
>
  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <mat-checkbox
        color="primary"
        (click)="$event.stopPropagation(); masterToggle()"
        [checked]="selectedUsers.hasValue() && isAllSelected()"
        [indeterminate]="isPartiallySelected()"
        [disabled]="userListDataSource === undefined"
      >
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let element">
      <mat-checkbox
        color="primary"
        (click)="$event.stopPropagation()"
        (change)="$event ? selectedRecords(element) : null"
        [checked]="selectedUsers.isSelected(element)"
      >
      </mat-checkbox>
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'USER_DETAILS.name' | translate }}
    </th>
    <td mat-cell *matCellDef="let element" class="preserve-whitespace">
      {{ element.name }}
      @if (element.isCompanyAdmin) {
      <mat-chip class="pointer">{{
        'COMPANY_ADD_USERS.admin' | translate | uppercase
      }}</mat-chip>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'USER_DETAILS.email' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.email }}</td>
  </ng-container>
  <ng-container matColumnDef="roleString">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'USER_DETAILS.roles' | translate }}
    </th>
    <td mat-cell *matCellDef="let element">{{ element.roleString }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    (click)="$event.stopPropagation(); selectedRecord(row)"
  ></tr>
</table>
<mat-paginator
  [ngClass]="_appUserServ.noRecordFound ? 'hide' : ''"
  #paginator
  [length]="displayUsers.total"
  showFirstLastButtons="true"
  [pageSizeOptions]="[10, 25, 50, 100]"
  (page)="getPagination($event)"
>
</mat-paginator>

<app-spinner [class.hide]="!_appUserServ.loading"></app-spinner>
